import { render, staticRenderFns } from "./CaseCustomerView.vue?vue&type=template&id=67bf8a83&scoped=true&"
import script from "./CaseCustomerView.vue?vue&type=script&lang=js&"
export * from "./CaseCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./CaseCustomerView.vue?vue&type=style&index=0&id=67bf8a83&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf8a83",
  null
  
)

export default component.exports